export default "__VITE_ASSET__D$ZYsDaZ__"